import { useCallback } from 'react';
import { useApiPost } from '@sierralabs/core-ui';
export function useImportEntity() {
    const { data, isLoading, error, post } = useApiPost('entities/import');
    const importEntity = useCallback((dto) => post(dto), [post]);
    return {
        importedEntity: data,
        isLoading,
        importError: error,
        importEntity
    };
}
//# sourceMappingURL=useImportEntity.js.map